import { render } from "./ModeloUpdatePagina.vue?vue&type=template&id=6f553851&scoped=true"
import script from "./ModeloUpdatePagina.vue?vue&type=script&lang=ts"
export * from "./ModeloUpdatePagina.vue?vue&type=script&lang=ts"

import "./ModeloUpdatePagina.vue?vue&type=style&index=0&id=6f553851&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f553851"

export default script